import { render, staticRenderFns } from "./FileQuestionItem.vue?vue&type=template&id=2c5ff82d&"
import script from "./FileQuestionItem.vue?vue&type=script&lang=js&"
export * from "./FileQuestionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports